

import { Component, Vue, Prop, Emit } from "vue-property-decorator"
import { Getter, Mutation, Action, State } from "vuex-class"

import api from "@/services/api"
import systemApi from "@/services/api/api_System"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { Feature, Tenant, TenantWithFeatures } from "@/types/tenant"

import DataTable from "@/components/Config/DataTable.vue"
import TenantFeatures from "./TenantFeatures.vue"
import TextAreaExpand from "@/components/Fields/TextAreaExpand.vue"
import { SystemUser } from "@/types/user"

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar,
		"data-table": DataTable,
		"text-area-expand": TextAreaExpand
	}
})
export default class TenantList extends Vue {
	@State public systemUser!: SystemUser
	@Action finishLogin!: () => Promise<void>

	features: Feature[] = []
	tenantsList: Tenant[] = []

	supportTenant: Tenant | null = null
	accessReason: string | null = null
	helpFeature: Feature | null = null
	helpFeatureDocs: string | null = null

	get columns () {
		return [{
			key: "title",
			label: "Title",
			sortable: true,
			readonly: true,
			inModal: () => false
		},
		{
			key: "features",
			label: "Features",
			inTable: false,
			dynamicComponent: TenantFeatures,
			componentProperties: {
				features: this.features
			},
			eventHandlers: {
				showHelp: (feature: Feature) => {
					this.helpFeatureDocs = "Loading"
					this.helpFeature = feature
					systemApi.featureDocumentationGet(feature.key).then(docs => {
						// replaceAll isn't behaving in ts, but is a member of string
						this.helpFeatureDocs = (docs as any).replaceAll("{{apiEndpoint}}",
							api.baseUrl)
					}).catch(() => {
						this.helpFeatureDocs = "Unable to load documentation"
					})
				}
			}
		}
		]
	}

	get accessModalOpen (): boolean {
		return !!this.supportTenant
	}
	set accessModalOpen (value: boolean) {
		if (!value) {
			this.supportTenant = null
			this.accessReason = null
		}
	}

	async mounted () {
		this.features = await systemApi.features()
		this.tenantsList = await systemApi.tenantsGet()
	}

	async loadTenantDetails (tenant: Tenant) {
		const tenantFeatures = await systemApi.enabledFeatures(tenant.id)
		return {
			id: tenant.id,
			title: tenant.title,
			features: tenantFeatures || {}
		}
	}

	async saveTenant (tenant: TenantWithFeatures) {
		systemApi.enabledFeaturesSet(tenant.id, tenant.features)
	}

	showAccess (accessTenant: Tenant) {
		this.supportTenant = accessTenant
	}

	async access () {
		if (!this.supportTenant || !this.accessReason) return

		await systemApi.accessTenant(this.supportTenant.id, this.accessReason)
		this.finishLogin()
	}

	helpClosed () {
		this.helpFeature = null
		this.helpFeatureDocs = ""
	}
}
